import { apiClient } from './client';
import { MembershipSummaryDto, CompanyDto } from '../types';

export interface MembershipSummaryParams {
  company?: string;
  brgId?: number;
}

export const membershipApi = {
  getSummary(params?: MembershipSummaryParams): Promise<MembershipSummaryDto> {
    const qs = new URLSearchParams();
    if (params?.company && params.company !== 'All Companies') {
      qs.set('company', params.company);
    }
    if (params?.brgId && params.brgId > 0) {
      qs.set('brgId', params.brgId.toString());
    }
    const query = qs.toString();
    return apiClient.get<MembershipSummaryDto>(
      `/api/brgs/membership-summary${query ? `?${query}` : ''}`
    );
  },
  
  getCompanies(): Promise<CompanyDto[]> {
    return apiClient.get<CompanyDto[]>('/api/companies');
  },
};
